export default __webpack_public_path__ + "static/images/223eec9238f6b0a76bd45c0cd707c57f.png";